import { Box, Button, Typography } from "@mui/material";
import { CALIBRATE_FONT_FAMILY_ACCENT } from "components/hoc/Theme";

interface CTABannerProps {
  onContactClick: () => void;
}

export default function CTABanner({ onContactClick }: CTABannerProps) {
  return (
    <Box
      sx={{
        width: "100%",
        py: 4,
        px: 2,
        backgroundColor: (theme) =>
          theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.05)"
            : "rgba(0,0,0,0.05)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        borderRadius: "8px",
        minHeight: "112px",
      }}
    >
      <Typography
        variant="body1"
        sx={{
          fontFamily: CALIBRATE_FONT_FAMILY_ACCENT,
          fontSize: "1rem",
          color: "text.primary",
          textAlign: "center",
        }}
      >
        Want to talk to our team about partnerships?
      </Typography>

      <Button
        variant="contained"
        onClick={onContactClick}
        sx={{
          fontFamily: CALIBRATE_FONT_FAMILY_ACCENT,
          fontSize: "0.9375rem",
          backgroundColor: "#31A0B1",
          color: "#FFFFFF",
          fontWeight: 500,
          textTransform: "uppercase",
          px: 3,
          py: 1,
          borderRadius: "6px",
          boxShadow: 2,
          "&:hover": {
            backgroundColor: "#257885",
            boxShadow: "0 4px 8px rgba(0,0,0,0.25)",
          },
          "&:active": {
            backgroundColor: "#185059",
            boxShadow: "0 1px 2px rgba(0,0,0,0.25)",
          },
        }}
      >
        Contact Our Partnership Team
      </Button>
    </Box>
  );
}
